export default function snakeCaseToPascalCase(snakeCase: string) {
    const pascalCase = snakeCase
        .split('_')
        .map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase())
        .join('')
    return pascalCase
}
